'use client';
import Slider, { CustomArrowProps, Settings } from 'react-slick';
import { FiChevronLeft, FiChevronRight } from 'react-icons/fi';

import { IBlogDictionary } from '@/dictionaries/pages/blog/types';
import BlogLastArticlesCard from './CarouselCard';
import { cn } from '@/lib/utils';
import { TranslatedBlogArticle } from '@/types/Blog';

import './styles.css';

function SampleNextArrow(props: CustomArrowProps) {
  const { className, onClick } = props;
  return (
    <div
      className={cn(
        className,
        'blog-la-button blog-la-next-button !flex items-center justify-center',
      )}
      onClick={onClick}>
      <FiChevronRight className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

function SamplePrevArrow(props: CustomArrowProps) {
  const { className, onClick } = props;
  return (
    <div
      className={cn(
        className,
        'blog-la-button blog-la-prev-button !flex items-center justify-center',
      )}
      onClick={onClick}>
      <FiChevronLeft className="w-6 h-6 desktop:w-8 desktop:h-8 stroke-slate-600 opacity-30 group-hover:opacity-20 transition" />
    </div>
  );
}

type Props = {
  dict: IBlogDictionary;
  lang: string;
  articles: TranslatedBlogArticle[];
};

export default function BlogLastArticlesCarousel({
  dict,
  lang,
  articles,
}: Props) {
  const settings: Settings = {
    centerMode: true,
    dots: true,
    infinite: true,
    speed: 1000,
    slidesToShow: 1,
    centerPadding: '13.104%',
    focusOnSelect: true,
    dotsClass: 'carousel-dots',
    nextArrow: <SampleNextArrow />,
    prevArrow: <SamplePrevArrow />,
    adaptiveHeight: true,
    responsive: [
      {
        breakpoint: 1199,
        settings: {
          slidesToShow: 3,
          centerPadding: '0px',
          centerMode: false,
        },
      },
      {
        breakpoint: 1099,
        settings: {
          slidesToShow: 2,
          centerPadding: '0px',
          centerMode: false,
        },
      },
      {
        breakpoint: 749,
        settings: {
          slidesToShow: 1,
          centerPadding: '0px',
          centerMode: false,
        },
      },
    ],
  };

  return (
    <div className="w-screen [@media(min-width:750px)]:w-[calc(100vw-5rem)] [@media(min-width:750px)]:mx-auto desktop:!w-[calc(100vw-10rem)]">
      <Slider className="last-articles-carousel" {...settings}>
        {articles.map((article) => (
          <BlogLastArticlesCard
            key={article.id}
            article={article}
            dict={dict}
            lang={lang}
          />
        ))}
      </Slider>
    </div>
  );
}
